import axios from '../base/axios';
import API_KEY from './key';

const GET_TVCRIME = 'flixfrenzy/redux/GET_TVCRIME';

// eslint-disable-next-line default-param-last
const tvCrimeReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVCRIME:
      return action.payload;
    default:
      return state;
  }
};

export const getTvCrime = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=80`).then((res) => {
    dispatch({
      type: GET_TVCRIME,
      payload: res.data,
    });
  });
};

export default tvCrimeReducer;
